import React from "react";
import "../styles/pagos.css";

const currency = new Intl.NumberFormat("es-EC", { style: "currency", currency: "USD" });

const EstadoChip = ({ estado, anulado }) => {
  if (anulado) return <span className="badge bg-danger text-uppercase">Anulado</span>;
  if (!estado) return <span className="badge bg-light text-dark">Sin estado</span>;
  const map = {
    pendiente: "warning",
    parcial: "info",
    pagado: "success",
    por_cobrar: "warning",
  };
  const label = estado === "por_cobrar" ? "Por cobrar" : estado;
  const color = map[estado] || "secondary";
  return <span className={`badge bg-${color} text-uppercase`}>{label}</span>;
};

const TipoPagoChip = ({ afectaMatricula, concepto, tipo }) => {
  if (tipo === "empresarial") {
    return (
      <span className="badge bg-purple bg-opacity-10" style={{ fontWeight: 500, background: "rgba(109,40,217,0.12)", color: "#7c3aed" }}>
        <i className="bi bi-building me-1" />
        Empresarial
      </span>
    );
  }
  if (afectaMatricula) {
    return (
      <span className="badge bg-primary bg-opacity-10 text-primary" style={{ fontWeight: 500 }}>
        <i className="bi bi-mortarboard me-1" />
        Matrícula
      </span>
    );
  }
  const label = concepto && concepto.toLowerCase() !== "cargos adicionales"
    ? concepto.charAt(0).toUpperCase() + concepto.slice(1).toLowerCase()
    : "Cargos";
  return (
    <span className="badge bg-warning bg-opacity-10 text-warning-emphasis" style={{ fontWeight: 500 }}>
      {label}
    </span>
  );
};

export default function PagosTable({
  pagos,
  loading,
  error,
  onSelect,
  seleccionadoId,
  page = 1,
  pageSize = 0,
  total = 0,
}) {
  const baseIndex = pageSize > 0 ? (Math.max(page, 1) - 1) * pageSize : 0;
  return (
    <div className="management-card pagos-table h-100 d-flex flex-column">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          <p className="management-eyebrow mb-1">Listado</p>
          <h6 className="mb-0">Pagos registrados</h6>
        </div>
        {loading && (
          <div className="text-muted small">
            <i className="bi bi-arrow-repeat me-2 spin" />
            Cargando...
          </div>
        )}
      </div>

      {error && <div className="alert alert-danger">Error: {error}</div>}

      <div className="table-responsive" style={{ WebkitOverflowScrolling: "touch" }}>
        <table className="table align-middle mb-0">
          <thead>
            <tr>
              <th>#</th>
              <th>Fecha</th>
              <th>Codigo</th>
              <th>Concepto</th>
              <th>Estudiante</th>
              <th>Monto</th>
              <th>Metodo</th>
              <th>Estado pago</th>
              <th>Referencia</th>
            </tr>
          </thead>
          <tbody>
            {pagos.length === 0 && (
              <tr>
                <td colSpan="9" className="text-center text-muted py-4">
                  {loading ? "Cargando..." : "Sin pagos registrados con los filtros actuales."}
                </td>
              </tr>
            )}
            {pagos.map((pago, idx) => {
              const ascIndex = baseIndex + idx + 1;
              const descIndex = total > 0 ? total - (baseIndex + idx) : ascIndex;
              const displayIndex = descIndex > 0 ? descIndex : ascIndex;
              return (
              <tr
                key={pago.id}
                className={seleccionadoId === pago.id ? "table-active" : ""}
                role="button"
                style={{
                  ...(pago.anulado ? { background: "rgba(239,68,68,0.06)", opacity: 0.8 } : {}),
                  ...(pago.tipo === "empresarial" && !pago.anulado ? { background: "rgba(109,40,217,0.04)" } : {}),
                }}
                onClick={() => onSelect?.(pago)}
              >
                <td>#{displayIndex}</td>
                <td>{pago.fechaPago ? new Date(pago.fechaPago).toLocaleString() : "-"}</td>
                <td>
                  {pago.tipo === "empresarial"
                    ? <span className="text-muted small">{pago.total_pagos} matrícula(s)</span>
                    : pago.codigoMatricula || (pago.matriculaId ? `#${pago.matriculaId}` : "N/D")}
                </td>
                <td>
                  <TipoPagoChip afectaMatricula={pago.afectaMatricula} concepto={pago.concepto} tipo={pago.tipo} />
                </td>
                <td>
                  {pago.tipo === "empresarial"
                    ? <><strong>{pago.empresa_nombre}</strong>{pago.empresa_ruc ? <span className="text-muted ms-1 small">{pago.empresa_ruc}</span> : null}</>
                    : pago.estudiante || "N/D"}
                </td>
                <td>
                  <strong>{currency.format(pago.monto || 0)}</strong>
                  {pago.tipo === "empresarial" && pago.saldo_favor > 0 && (
                    <div className="text-muted" style={{ fontSize: "0.72rem" }}>
                      Saldo: {currency.format(pago.saldo_favor)}
                    </div>
                  )}
                </td>
                <td className="text-capitalize">{pago.metodoPago}</td>
                <td><EstadoChip estado={pago.afectaMatricula ? pago.estadoPago : (pago.cargoEstado || "pagado")} anulado={pago.anulado} /></td>
                <td className="text-truncate" style={{ maxWidth: 160 }}>
                  {pago.referencia || <span className="text-muted">-</span>}
                </td>
              </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
